<template>
    <div>
        <v-progress-linear v-if="loading" height="2" indeterminate></v-progress-linear>
        <div v-else class="mt-3">
        <!--<v-container fluid>-->
            <v-layout grid-list-md wrap mb-2>
                <v-flex class="text-xs-right" xs12 style="margin-right: 5px; margin-top: -10px; text-align: left">

                    <v-menu offset-x>
                        <template v-slot:activator="{ on }">
                            <v-chip small v-ripple :disabled="sorting" :color="sorting ? 'grey lighten-2' : 'primary'" text-color="white" v-on="on" style="cursor: pointer">
                                <div v-if="!sorting">
                                    {{sortOptionChosenTitle}}
                                    <v-icon right>sort</v-icon>
                                </div>
                                <v-progress-circular v-else indeterminate color="primary" m-2 size="15" width="2"></v-progress-circular>
                            </v-chip>
                        </template>
                        <v-list>
                            <v-list-tile
                                    v-for="(item, index) in mSortOptions"
                                    :key="index"
                                    item-text="name"
                                    item-value="id"
                                    @click="sortDashboard(index)"
                            >
                                <v-list-tile-title :style="[sortOptionChosenIndex === index ? {'color': 'blue'} : {'color':''}]">{{ item.title }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                </v-flex>
                <v-flex xs12 sm6 md3>
                    <report-box m-icon="account_circle" :name="'Total Clientes'" :mValue="totalClients" :color="'indigo'"></report-box>
                </v-flex>
                <v-flex xs12 sm6 md3>
                    <report-box m-icon="card_travel" :padding="4" :name="'Total orçamentado'" :mValue="formatPrice(totalBudgets)" m-value-suffix="Ecv" :color="'info'"></report-box>
                </v-flex>
                <v-flex xs12 sm6 md3>
                    <report-box m-icon="assignment" :name="'Total Faturado'" :mValue="formatPrice(totalInvoice)" m-value-suffix="Ecv" :color="'orange'"></report-box>
                </v-flex>
                <v-flex xs12 sm6 md3>
                    <report-box m-icon="paid" :name="'Total Recebido'" :mValue="formatPrice(totalReceipt)" m-value-suffix="Ecv" :color="'success'"></report-box>
                </v-flex>
            </v-layout>
        <!--</v-container>-->

            <v-card tile class="mVcard">
                <v-layout v-if="loadGraphs" grid-list-md wrap mb-5>
                    <v-flex class="text-xs-right">
                        <v-chip :outline="graphType !== 'Linha'" small :color="'#b4b4b0'" :text-color="graphType === 'Linha' ? 'white' : ''" @click="graphType = 'Linha'" style="cursor: pointer">Linha</v-chip>
                        <v-chip :outline="graphType !== 'Barra'" small :color="'#b4b4b0'" :text-color="graphType === 'Barra' ? 'white' : ''" @click="graphType = 'Barra'" style="cursor: pointer">Barra</v-chip>
                    </v-flex>
                    <v-flex xs12 >
                        <!--mColor="#FB8C00" mBorderColor="rgba(251, 140, 0, 0.2)" mLabel="faturado" :mRows="emitedInvoicesRows" :mLabels="emitedInvoicesLabels"-->
                        <dashboard-graph :m-graph-type="graphType" :m-data-set="datasets" :m-labels="datalabels"></dashboard-graph>
                    </v-flex>
                    <!--<v-flex xs6 >-->
                    <!--<dashboard-graph mColor="#43A047" mLabel="recibos" :mRows="emitedReceiptRows" :mLabels="emitedReceiptLabels"></dashboard-graph>-->
                    <!--</v-flex>-->
                </v-layout>

                <div v-if="datalabels.length > 0" style="background-color: white; margin-left: 20px; margin-right: 20px; margin-top: -40px; border-style: solid; border-width: 0.5px; border-color: #bbbbbb">
                    <v-layout wrap>
                        <v-flex xs6 sm4 md3 lg2 v-for="(mLabel, index) in emitedInvoices.labels" :key="index" style="padding: 5px">
                            <div>
                                <p style="font-size: 14px; margin-bottom: 0">{{getLabelByDate(mLabel)}}</p>
                                <li style="margin-left: 8px; font-size: 12px; color: orange"> <span style="color: grey">Faturado: </span><span style="color: black">{{emitedInvoices.rows[index] | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</span></li>
                                <li style="margin-left: 8px; font-size: 12px; color: #e3e300"> <span style="color: grey">Pendente: </span><span style="color: black">{{emitedInvoices.pendents[index] | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</span></li>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card>

            <!--Pizza graphs and Tables-->
        <br>
            <v-card class="mx-auto" marginleft="20px" tile>
                <v-card-title>
                
                <span class="title font-weight-light">Artigos (valores faturados)</span>
                </v-card-title>
                <v-divider></v-divider>

                <div v-if="loadingTables" style="margin-left: 10px; margin-top: 20px">
                    <v-layout align-start justify-center wrap>
                        <v-flex xs12 sm6 md4>
                            <data-viewer-switch title="Maiores receitas por artigos" :filteredItems="filteredArticles"></data-viewer-switch>
                        </v-flex>
                        <v-flex xs12 sm6 md4 >
                            <data-viewer-switch title="Maiores receitas por categoria-artigos" :filteredItems="filteredArticlesByCategories"></data-viewer-switch>
                        </v-flex>
                        <v-flex xs12 sm6 md4 >
                            <data-viewer-switch title="Maiores receitas por subcategoria-artigos" :filteredItems="filteredArticlesBySubCategories"></data-viewer-switch>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card>
            <br>
            <br>
            <v-card class="mx-auto">
                <v-card-title>
                
                <span class="title font-weight-light">Clientes (valores recebidos)</span>
                </v-card-title>
                <v-divider></v-divider>
                <div v-if="loadingTables" style="margin-left: 10px; margin-top: 20px">
                    <v-layout align-start justify-center wrap>
                        <v-flex xs12 sm6 md4>
                            <data-viewer-switch title="Maiores receitas por clientes" :filteredItems="filteredClients"></data-viewer-switch>
                        </v-flex>
                        <v-flex xs12 sm6 md4 >
                            <data-viewer-switch title="Maiores receitas por categoria-clientes" :filteredItems="filteredClientsByCategories"></data-viewer-switch>
                        </v-flex>
                        <v-flex xs12 sm6 md4 >
                            <data-viewer-switch title="Maiores receitas por subcategoria-clientes" :filteredItems="filteredClientsBySubCategories"></data-viewer-switch>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card>
        </div>

        <!--Choose dates-->
        <v-dialog max-width="500px" v-model="showChooseDates" @close="closeChooseDates">
            <v-card flat>

                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm6>
                            <v-menu
                                    ref="dataMenu1"
                                    v-model="filterBeginDateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            :value="computedFilterBeginDate"
                                            label="Data Min."
                                            prepend-icon="event"
                                            clearable
                                            @click:clear="filterBeginDate = ''"
                                            px-2
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker locale="pt" v-model="filterBeginDate" no-title @input="filterBeginDateMenu = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-menu
                                    ref="dataMenu1"
                                    v-model="filterEndDateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            :value="computedFilterEndDate"
                                            label="Data Máx."
                                            prepend-icon="event"
                                            clearable
                                            @click:clear="filterEndDate = ''"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker locale="pt" v-model="filterEndDate" no-title @input="filterEndDateMenu = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                </v-card-text>


                <v-card-actions style="margin-top: -20px">
                    <v-btn small ma-2 depressed @click="closeChooseDates()">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn small ma-2 color="primary" @click="confirmChooseDates">Filtrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import ReportBox from './../extra/ReportBox'
    import Vue from 'vue';
    import moment from 'moment';
    import {General} from "../../config";
    import DataViewerSwitch from "./DataViewerSwitch";
import { _ } from 'core-js';
    

    export default {
        name: "Dashboard",

        mounted(){
            let vm = this;
            this.load();
            this.loadGraph();
            this.loadTables();
        },

        data(){
            return{
                loading: false,
                loadGraphs: false,
                loadingTables: false,
                totalClients: 0,
                totalBudget: 0,
                totalInvoice: 0,
                totalReceipt: 0,
                totalBudgets: 0,

                emitedInvoices: [],
                emitedInvoicesRows: [],
                emitedInvoicesLabels: [],
                emitedReceiptRows: [],
                emitedReceiptLabels: [],

                mSortOptions: [
                    {title: 'Esta semana'},
                    {title: 'Este mês'},
                    {title: 'Este ano'},
                    {title: 'Desde sempre'},
                    {title: 'Escolha uma data'},
                ],
                sortOptionChosenIndex: 1,
                showChooseDates: false,
                filterBeginDateMenu: false,
                filterEndDateMenu: false,
                filterBeginDate: '',
                filterEndDate: '',
                datalabels: '',
                error_fetching: false,

                graphType: 'Barra',
                graphTypes: ['Linha', 'Barra'],

                filteredArticles: [],
                filteredArticlesByCategories: [],
                filteredArticlesBySubCategories: [],
                filteredClients: [],
                filteredClientsByCategories: [],
                filteredClientsBySubCategories: [],
            }
        },

        components: {
            DataViewerSwitch,
            // LineChart,
            ReportBox,
        },

        computed: {
            sortOptionChosenTitle(){
                if(this.sortOptionChosenIndex < 0) return '';
                if(this.sortOptionChosenIndex === 4){
                    let beginDateString = '';
                    let endDateString = '';
                    if(this.filterBeginDate) beginDateString = moment(this.filterBeginDate).format('DD-MM-YYYY');
                    if(this.filterEndDate) endDateString = moment(this.filterEndDate).format('DD-MM-YYYY');
                    return beginDateString+' até '+endDateString;
                }

                return this.mSortOptions[this.sortOptionChosenIndex].title;
            },
            sorting(){
                return this.loading && this.loadGraphs && this.loadingTables;
            },
            computedFilterBeginDate:{
                get(){
                    return this.filterBeginDate ? moment(this.filterBeginDate).format('DD-MM-YYYY') : '';
                },
                set(value){
                    this.filterBeginDate = new Date(value).toISOString().substr(0, 10);
                }
            },
            computedFilterEndDate:{
                get(){
                    return this.filterEndDate ? moment(this.filterEndDate).format('DD-MM-YYYY') : '';
                },
                set(value){
                    this.filterEndDate = new Date(value).toISOString().substr(0, 10);
                }
            },
        },

        methods: {
            load(){
                this.loading = true;
                Vue.axios.get('load', {params: {
                        sortBeginDate: this.getSortBeginDate(),
                        sortEndDate: this.getSortEndDate(),
                    }})
                    .then( response => {
                        // this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.totalClients = response.data.response.totalClients;
                        this.totalInvoice = response.data.response.totalInvoices;
                        this.totalReceipt = response.data.response.totalReceipts;
                        this.totalBudgets = response.data.response.totalBudgets;

                    }).catch( error => {
                        this.consoleLog(error);
                    }).finally(()=>{
                        this.loading = false;
                    })
            },

            loadGraph(){
                this.loadGraphs = false;
                Vue.axios.get('load_graphs', {params: {
                    sortBeginDate: this.getSortBeginDate(),
                    sortEndDate: this.getSortEndDate(),
                    grouping: this.sortOptionChosenIndex,
                }})
                .then( response => {
                    // this.consoleLog(response);
                    if(!response.data.success){
                        this.handleErrorCodeMessage(response.data);

                        return;
                    }
                    this.emitedInvoices = response.data.response.emittedInvoices;
                    this.prepareDataSet(response.data.response);

                }).catch( error => {
                    this.consoleLog(error);
                }).finally(()=>{
                    this.loadGraphs = true;
                })
            },

            loadTables(){
                this.loadingTables = false;
                this.error_fetching = false;
                Vue.axios.get('load_tables', {params: {
                        sortBeginDate: this.getSortBeginDate(),
                        sortEndDate: this.getSortEndDate(),
                    }})
                    .then( response => {
                        this.consoleLog('loadTables:',response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.filteredArticles = this.filterOutNull(response.data.response.topSoldArticles);
                        this.filteredArticlesByCategories = this.filterOutNull(response.data.response.topSoldArticlesByCategory);
                        this.filteredArticlesBySubCategories = this.filterOutNull(response.data.response.topSoldArticlesBySubCategory);

                        this.filteredClients = this.filterOutNull(response.data.response.topSoldClients);
                        this.filteredClientsByCategories = this.filterOutNull(response.data.response.topSoldClientsByCategory, 'Categoria');
                        this.filteredClientsBySubCategories = this.filterOutNull(response.data.response.topSoldClientsBySubCategory, 'Subcategoria');

                    }).catch( error => {
                    this.consoleLog(error);
                }).finally(()=>{
                    this.loadingTables = true;
                })
            },

            filterOutNull(mArray, name){
                let newArray = [];
                mArray.forEach(element => {
                    if(element.id == null) element.name = 'Sem '+name;
                    newArray.push(element);
                });
                return newArray;
            },

            prepareDataSet(response){
                let mArray = [];
                mArray.push({
                    'data': response.emittedInvoices.rows,
                    'labels': response.emittedInvoices.labels,//not actually used its here only to seen in console
                    'borderColor': 'rgba(251, 140, 0, 0.9)',
                    'backgroundColor': "rgba(251, 140, 0, 0.2)",
                    'label': "faturado",
                    'borderWidth': 2,
                });

                mArray.push({
                    'data': response.emittedInvoices.pendents,
                    'labels': response.emittedInvoices.labels,//not actually used its here only to be seen in console
                    'borderColor': 'rgba(255, 234, 0, 0.9)',
                    'backgroundColor': 'rgba(255, 234, 0, 0.2)',
                    'label': "pendente",
                    'borderWidth': 2,
                });
                this.datasets = JSON.stringify(mArray);
                this.datalabels = JSON.stringify(this.getLabels(response.emittedInvoices.labels));
                this.loadGraphs = true;
            },

            getLabels(dates){
                let newArray = [];
                for (let i = 0; i < dates.length; i++) {
                    newArray.push(this.getLabelByDate(dates[i]));
                }
                return newArray;
            },

            getLabelByDate(date){
                if(this.sortOptionChosenIndex === 0){
                    // let weekDaysName = ['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'];
                    // let day = (moment(date, 'YYYY/MM/DD', General.REGION)).day();
                    // this.consoleLog('day: '+day);
                    // return General.WEEK_DAYS_STR[day];
                    return moment(date, 'DD/MM/YY', General.REGION).locale(General.Locale).format('dddd');
                } else if(this.sortOptionChosenIndex === 2){
                    // let month = (moment(date, 'MM/YYYY')).month();
                    // return General.MONTH_DAYS_STR[month];
                    // let monthDaysName = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
                    return moment(date, 'MM/YYYY', General.REGION).locale(General.Locale).format('MMMM');
                } else {
                    return date;
                }

            },

            getSortBeginDate(){
                let data;
                switch (this.sortOptionChosenIndex) {
                    case 0:
                        data = moment().day(1); // this Monday (1)
                        break;
                    case 1:
                        data = moment(1, "DD"); // this month, 1st day-of-month
                        break;
                    case 2:
                        data = moment(1, "MM");  // this year, 1st month (January)
                        break;
                    case 3:
                        return undefined; // no limitation for date
                    case 4:
                        data = moment(this.filterBeginDate);
                        break;
                    default:
                        data = moment().subtract(15, 'day');
                        break;
                }
                return data.set({hour:0,minute:0,second:0,millisecond:0}).format('YYYY-MM-DD HH:mm:ss')
            },

            getSortEndDate(){
                let data;
                if(!this.filterEndDate) return '';

                if(this.sortOptionChosenIndex === 4) {
                    data = moment(this.filterEndDate);
                }else{
                    data = moment();
                }
                return data.set({hour:23,minute:59,second:59,millisecond:0}).format('YYYY-MM-DD HH:mm:ss');
            },

            sortDashboard(index){
                this.sortOptionChosenIndex = index;
                let vm = this;
                if(this.sortOptionChosenIndex !== 4){
                    this.filterBeginDate = '';
                    this.filterEndDate = '';
                    this.load();
                    this.loadGraph();
                    this.loadTables();
                }else{
                    this.showChooseDates = true;
                }
            },

            confirmChooseDates(){
                this.load();
                this.loadGraph();
                this.loadTables();
                this.showChooseDates = false;
            },

            closeChooseDates(){
                this.showChooseDates = false;
            }
        }
    }
</script>

<style scoped>
    .mVcard {
        padding: 10px 10px 30px;
        margin: 10px;
    }
</style>